import React, { ReactNode, useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import { Actions, LoggedInState, State } from "../../types";
import { JobList } from "./JobList";
import { Settings } from "./Settings";

enum ActiveTab {
  jobs = "jobs",
  settings = "settings",
  help = "help",
}

type Props = Readonly<{
  actions: Actions;
  auth: LoggedInState;
  blockingStep: string;
  customSettings: ReactNode | null;
  docs?: React.ReactElement;
  jobs: State["jobs"];
  jobState: State["job"];
}>;

export const Authenticated = ({
  actions,
  auth,
  blockingStep,
  customSettings,
  docs,
  jobs,
  jobState,
}: Props) => {
  const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.jobs);
  useEffect(() => {
    setActiveTab(ActiveTab.jobs);
  }, [auth.activeKey]);
  return (
    <div className="d-flex flex-column h-100 p-3">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === ActiveTab.jobs ? "active" : ""}
            onClick={() => {
              setActiveTab(ActiveTab.jobs);
            }}
          >
            Jobs
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === ActiveTab.settings ? "active" : ""}
            onClick={() => {
              setActiveTab(ActiveTab.settings);
            }}
          >
            <i aria-label="Settings" className="fa fa-cogs" />
          </NavLink>
        </NavItem>
        {!!docs && (
          <NavItem>
            <NavLink
              className={activeTab === ActiveTab.help ? "active" : ""}
              onClick={() => {
                setActiveTab(ActiveTab.help);
              }}
            >
              <i aria-label="Settings" className="fa fa-question-circle" />
            </NavLink>
          </NavItem>
        )}
      </Nav>
      <TabContent activeTab={activeTab} className="flex-fill overflow-hidden">
        <TabPane
          tabId={ActiveTab.jobs}
          className="border-bottom border-left border-right h-100 overflow-hidden p-2"
        >
          <JobList
            actions={actions}
            auth={auth}
            blockingStep={blockingStep}
            jobs={jobs}
            jobState={jobState}
          />
        </TabPane>
        <TabPane
          tabId={ActiveTab.settings}
          className="border-bottom border-left border-right h-100 overflow-hidden p-2 "
          style={{ overflowX: "hidden", overflowY: "auto" }}
        >
          <Settings actions={actions} auth={auth} customSettings={customSettings} />
        </TabPane>
        {!!docs && (
          <TabPane
            tabId={ActiveTab.help}
            className="border-bottom border-left border-right h-100 overflow-hidden p-2 "
            style={{ overflowX: "hidden", overflowY: "auto" }}
          >
            {docs}
          </TabPane>
        )}
      </TabContent>
    </div>
  );
};
Authenticated.displayName = "Authenticated";
